import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import useScrollBehavior from './useScrollBehavior';
import Logo from '../../components/logo';
import './header.css';

function Header() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { scrollToTop } = useScrollBehavior();

    const handleSectionClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
        if (e.ctrlKey || e.metaKey || e.shiftKey) {
            return;
        }

        e.preventDefault();
        navigate(`/#${sectionId}`, { replace: location.pathname === '/' });
    };

    const handleHomeClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (e.ctrlKey || e.metaKey || e.shiftKey) {
            return;
        }

        e.preventDefault();

        if (location.pathname === '/') {
            scrollToTop();
            navigate('/', { replace: true });
        } else {
            navigate('/');
        }
    };

    return (
        <header className="header">
            <div className="header__container">
                <Link to="/" onClick={(e) => handleHomeClick(e)} className="header__logo">
                    <Logo />
                </Link>

                <nav className="header__desktop-nav">
                    <Link to="/" onClick={handleHomeClick}>
                        Welcome
                    </Link>
                    <Link to="/#features" onClick={(e) => handleSectionClick(e, 'features')}>
                        Purpose
                    </Link>
                    <Link to="/#approach" onClick={(e) => handleSectionClick(e, 'approach')}>
                        Approach
                    </Link>
                </nav>

                <div className="header__actions">
                    <Link
                        to="/user/registration"
                        className="sp-btn sp-btn--primary header__desktop-action"
                    >
                        Get Started
                    </Link>
                    <Link
                        to="/user/login"
                        className="sp-btn sp-btn--outline header__desktop-action"
                    >
                        Log in
                    </Link>

                    <button
                        className="header__mobile-menu-btn"
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    >
                        {mobileMenuOpen ? (
                            <X className="sp-icon-md" />
                        ) : (
                            <Menu className="sp-icon-md" />
                        )}
                    </button>
                </div>
            </div>

            {mobileMenuOpen && (
                <div className="header__mobile-menu">
                    <nav className="header__mobile-nav">
                        <Link
                            to="/"
                            className="header__mobile-nav-link"
                            onClick={(e) => {
                                handleHomeClick(e);
                                setMobileMenuOpen(false);
                            }}
                        >
                            Welcome
                        </Link>
                        <Link
                            to="/#features"
                            className="header__mobile-nav-link"
                            onClick={(e) => {
                                handleSectionClick(e, 'features');
                                setMobileMenuOpen(false);
                            }}
                        >
                            Features
                        </Link>
                        <Link
                            to="/#approach"
                            className="header__mobile-nav-link"
                            onClick={(e) => {
                                handleSectionClick(e, 'approach');
                                setMobileMenuOpen(false);
                            }}
                        >
                            Approach
                        </Link>
                        <Link to="/user/registration" className="sp-btn sp-btn--primary">
                            Get Started
                        </Link>
                        <Link to="/user/login" className="sp-btn sp-btn--outline">
                            Log in
                        </Link>
                    </nav>
                </div>
            )}
        </header>
    );
}

export default Header;
